module.exports = __webpack_public_path__ + "img/start.919bf181.svg";